import * as React from "react";
import { RewardPanelImage } from "../../MyAccount/MyRewardProfile/reward-panel-image";

export const RewardsDetailsColumn: React.FunctionComponent = () => {
  return (
    <div className="rewards-details-column">
      <RewardPanelImage />
    </div>
  );
};
